import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/color-palettes";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (value) => {
  return await axiosInstance(options).get(`${path}/details?_id=${value}`);
};

export const Add = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const Status = async (values) => {
  return await axiosInstance(options).patch(`${path}/change-status`, values);
};

export const Delete = async (values) => {
  return await axiosInstance(options).delete(`${path}/delete?_id=${values._id}`, values);
};

export const Edit = async (values) => {
  return await axiosInstance(options).post(`${path}/edit`, values);
};

export const Reorder = async (values) => {
  return await axiosInstance(options).put(`${path}/reorder`, values);
};
